function loadMoreProducts() {
  const $productList = $('.product-list');
  const nextUrl = $productList.data('next-url');
  const $loadMoreBtn = $('.load-more_btn');

  if (!nextUrl) return;

  // Mostrar loading si quieres
  $('.load-more_spinner').show();
  $loadMoreBtn.text('Cargando...');

  $.get(nextUrl, function (response) {
    const html = $.parseHTML(response);
    const $newProductList = $(html).find('.product-list');
    const $newProductCards = $newProductList.find('product-card');

    $productList.append($newProductCards);

    const updatedNextUrl = $newProductList.data('next-url');

    if (updatedNextUrl && updatedNextUrl.trim() !== '') {
      $productList.attr('data-next-url', updatedNextUrl);
      $productList.data('next-url', updatedNextUrl);
      $loadMoreBtn.text('Ver más productos');
    } else {
      $loadMoreBtn
        .text('No hay más productos')
        .css('pointer-events', 'none') // desactiva clics
        .css('opacity', '0.5');
    }

    $('.load-more_spinner').hide();
    setupScrollReveal(); // si usas animación
  });
}


function setupScrollReveal() {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target); // solo una vez
        }
      });
    }, {
      threshold: 0.1
    });

    document.querySelectorAll('[reveal-on-scroll=true]:not(.revealed)').forEach(el => {
      observer.observe(el);
    });
  }
}